import { Outlet, Link } from 'react-router-dom';
import { Building2, LayoutDashboard, Home, Settings, LogOut } from 'lucide-react';

/**
 * Admin layout placeholder
 * Will be replaced with TailAdmin integration
 */
export function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar placeholder */}
      <aside className="fixed right-0 top-0 h-full w-64 bg-slate-900 text-white p-4">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center">
            <Building2 className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold">لوحة التحكم</span>
        </div>

        <nav className="space-y-2">
          <Link
            to="/admin"
            className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition-colors"
          >
            <LayoutDashboard className="w-5 h-5" />
            <span>الرئيسية</span>
          </Link>
          <Link
            to="/admin/properties"
            className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition-colors"
          >
            <Home className="w-5 h-5" />
            <span>العقارات</span>
          </Link>
          <Link
            to="/admin/settings"
            className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-slate-800 transition-colors"
          >
            <Settings className="w-5 h-5" />
            <span>الإعدادات</span>
          </Link>
        </nav>

        <div className="absolute bottom-4 right-4 left-4">
          <button className="flex items-center gap-3 px-4 py-3 w-full rounded-lg hover:bg-slate-800 transition-colors text-slate-400">
            <LogOut className="w-5 h-5" />
            <span>تسجيل الخروج</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="mr-64 p-8">
        <Outlet />
      </main>
    </div>
  );
}
